// extracted by mini-css-extract-plugin
export default {"conversationIcon":"conversationIcon__CommunicationPanelButton__5d0zE","communicationPanelButton":"communicationPanelButton__CommunicationPanelButton__5d0zE"};